<template>
  <el-dialog :visible="show" append-to-body :title="row ? `新增县级` : '修改县级'" width="500px" @close="closeDialog">
    <el-form label-width="100px" ref="vForm" :model="vForm" size="medium">
      <el-form-item label="排序" prop="sort" :rules="{ required: true, message: '排序必填' }">
        <el-input v-model="vForm.sort"></el-input>
        <div class="v-form-tips">排序值越小越靠前</div>
      </el-form-item>
      <el-form-item label="所属小程序" class="form-group" prop="shop_id" :rules="{ required: true, message: '小程序必选' }">
        <el-select v-model="vForm.shop_id" placeholder="请选择" style="width: 100%">
          <el-option v-for="item in wxList" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="地域名称" prop="name" :rules="{ required: true, message: '地域名称必填' }">
        <el-input v-model="vForm.name"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" size="small">关闭</el-button>
      <el-button type="primary" @click="doSubmit" :loading="doSubmitLoading" size="small">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => ({}),
    },
    wxList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      doSubmitLoading: false,
      vForm: {
        sort: 0,
        id: '',
        name: '',
        shop_id: '',
        level: 1,
      },
    };
  },

  created() {
    if (this.row) {
      for (let key in this.vForm) {
        this.vForm[key] = this.row[key];
      }
    }
  },

  methods: {
    closeDialog() {
      this.$emit('update:show', false);
    },

    //提交表单
    async doSubmit() {
      this.doSubmitLoading = true;
      try {
        await this.$refs.vForm.validate();
        await this.api.regionAdmin[this.row ? 'edit' : 'add'](this.vForm);
        this.$message.success(!this.row ? '添加成功' : '修改成功');
        this.$emit('success');
        this.closeDialog();
      } catch (e) {
        console.error(e);
      }
      this.doSubmitLoading = false;
    },
  },
};
</script>
